import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';

export const StyledListVoice = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const StyledVoiceList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
  &.scrollbar-custom {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
  }
`;

export const StyledVoiceItem = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #1e164e29;
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  .returning-error-icon {
    color: ${COLOR.redPrimary};
    font-size: 14px;
    cursor: pointer;
  }
`;

export const StyledSpeakerItemWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const StyledErrorMessageWrapper = styled('div')`
  width: 100%;
`;

export const StyledErrorMessage = styled(Typography)`
  font-family: 'SF Pro Text', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: ${COLOR.redPrimary};
  margin-top: 0;
`;
